import { useTheme } from '@mui/material';
import ColorLogoWhite from '../../../assets/icons/admiin-logo-colour-white.svg';
import ColorLogoDark from '../../../assets/icons/admiin-logo-colour.svg';
import LoadSvgIcon from '../../component/LoadSvgIcon/LoadSvgIcon';

export function AdmiinLogo({
  overrideTheme,
  width = '155px',
  height = '51px',
}: {
  overrideTheme?: 'dark' | 'light';
  width?: string;
  height?: string;
}) {
  const theme = useTheme();
  const mode = overrideTheme ?? theme.palette.mode;
  return mode === 'dark' ? (
    <LoadSvgIcon component={ColorLogoWhite} width={width} height={height} />
  ) : mode === 'light' ? (
    <LoadSvgIcon component={ColorLogoDark} width={width} height={height} />
  ) : (
    <LoadSvgIcon component={ColorLogoWhite} width={width} height={height} />
  );
}

export default AdmiinLogo;
